import {
  GridInputValue,
  LayoutCanvas,
  LayoutInlineForm,
  LayoutObject,
} from '../../types/types';
import { isValidatableLayoutItem } from './isValidatableLayoutItem';
import { validateLayoutItemValue } from './validateLayoutItemValue';

export type LayoutContentError = {
  scope: 'canvas' | 'object';
  // Object index within the layout; undefined for canvas errors.
  index?: number;
  field: string;
  // Translation key of the validation message.
  errorKey: string;
};

// Validates the layout content against the definition forms before the PUT:
// mandatory items must be filled, filled values must pass the field rules.
// canvas = undefined skips the canvas (fixed layouts don't save it).
export const validateLayoutContent = (
  canvas: LayoutCanvas | undefined,
  objects: LayoutObject[],
  canvasForm: LayoutInlineForm | undefined,
  objectForm: LayoutInlineForm | undefined
): LayoutContentError[] => {
  const errors: LayoutContentError[] = [];

  if (canvas && canvasForm) {
    canvasForm.items.filter(isValidatableLayoutItem).forEach((item) => {
      const errorKey = validateLayoutItemValue(
        item,
        canvas[item.name as string] as GridInputValue
      );
      if (errorKey) {
        errors.push({ scope: 'canvas', field: item.name as string, errorKey });
      }
    });
  }

  objects.forEach((object, index) => {
    (objectForm?.items ?? [])
      .filter(isValidatableLayoutItem)
      .forEach((item) => {
        const errorKey = validateLayoutItemValue(
          item,
          object[item.name as string] as GridInputValue
        );
        if (errorKey) {
          errors.push({
            scope: 'object',
            index,
            field: item.name as string,
            errorKey,
          });
        }
      });
  });

  return errors;
};
